{
  "unknown": "Something went wrong. Try again; if it keeps happening, show this screen to your administrator.",
  "network": {
    "unreachable": "Could not reach the server. Check your network connection and try again.",
    "badResponse": "The response from {{path}} does not match the expected format. The platform and the browser are probably on different versions: reload the page."
  },
  "validation": {
    "badRequest": "The request contains invalid data"
  },
  "code": {
    "byStatus": "The server replied with error {{status}}",
    "INTERNAL_ERROR": "Internal server error. Try again later.",
    "VALIDATION_FAILED": "The request contains invalid data",
    "NOT_FOUND": "Resource not found",
    "CONFLICT": "The action conflicts with the current state",
    "RATE_LIMITED": "Too many requests. Try again later.",
    "SERVICE_UNAVAILABLE": "The service is temporarily unavailable",
    "UNAUTHENTICATED": "Sign in to continue",
    "INVALID_CREDENTIALS": "Wrong email or password",
    "TOKEN_EXPIRED": "Your session has expired. Sign in again.",
    "TOKEN_INVALID": "The session is no longer valid. Sign in again.",
    "REFRESH_TOKEN_REUSED": "The session was ended for security reasons. Sign in again.",
    "USER_INACTIVE": "The account is disabled",
    "PERMISSION_DENIED": "You do not have permission for this action",
    "ORGANIZATION_NOT_FOUND": "Organization not found",
    "USER_NOT_FOUND": "User not found",
    "SITE_NOT_FOUND": "Site not found",
    "NODE_NOT_FOUND": "Node not found",
    "MONITOR_NOT_FOUND": "Monitor not found",
    "CREDENTIAL_NOT_FOUND": "Credential not found",
    "CAMERA_NOT_FOUND": "Camera not found",
    "SESSION_NOT_FOUND": "Session not found",
    "AGENT_NOT_FOUND": "Agent not found",
    "AGENT_OFFLINE": "The site agent is not connected. Check whether the netdeck-agent service is running.",
    "ENROLLMENT_TOKEN_INVALID": "The one-time token is not valid",
    "ENROLLMENT_TOKEN_USED": "The one-time token has already been used",
    "TUNNEL_STREAM_FAILED": "The stream to the site agent broke off",
    "TUNNEL_WINDOW_EXHAUSTED": "The channel to the agent is full: the agent is not reading fast enough",
    "VNC_TICKET_INVALID": "The connection ticket is invalid or expired. Connect again.",
    "VNC_PORT_CLOSED": "The VNC port is closed: the server is not running or listens on another port.",
    "VNC_HOST_UNREACHABLE": "The node is unreachable over the network",
    "VNC_TIMEOUT": "The VNC server did not answer in time",
    "VNC_PROTOCOL_ERROR": "The VNC server broke the protocol",
    "VNC_VERSION_UNSUPPORTED": "This RFB protocol version is not supported",
    "VNC_SECURITY_TYPE_UNSUPPORTED": "This VNC authentication method is not supported",
    "VNC_AUTH_FAILED": "The VNC server rejected the password",
    "VNC_NO_CREDENTIAL": "No VNC credential is attached to this node",
    "VNC_SERVER_CLOSED": "The VNC server closed the connection",
    "VNC_SESSION_LIMIT_REACHED": "The limit of simultaneous sessions is reached",
    "SSH_TICKET_INVALID": "The connection ticket is invalid or expired. Connect again.",
    "SSH_PORT_CLOSED": "The SSH port is closed: the server is not running or listens on another port.",
    "SSH_HOST_UNREACHABLE": "The node is unreachable over the network",
    "SSH_TIMEOUT": "The SSH server did not answer in time",
    "SSH_PROTOCOL_ERROR": "The SSH server broke the protocol",
    "SSH_HOST_KEY_CHANGED": "The host key differs from the pinned one",
    "SSH_HOST_KEY_UNTRUSTED": "The host key is not pinned",
    "SSH_AUTH_FAILED": "The server rejected the login",
    "SSH_AUTH_METHOD_UNSUPPORTED": "The server does not accept this login method",
    "SSH_NO_CREDENTIAL": "No SSH credential is attached to this node",
    "SSH_KEY_INVALID": "The private key could not be read",
    "SSH_NO_MATCHING_ALGORITHM": "No algorithm is shared with the server",
    "SSH_SERVER_CLOSED": "The SSH server closed the connection",
    "SSH_SESSION_LIMIT_REACHED": "The limit of simultaneous sessions is reached",
    "SSH_SFTP_UNSUPPORTED": "The server does not support file transfer over SFTP",
    "FILE_TRANSFER_UNSUPPORTED": "The server does not support file transfer",
    "FILE_NOT_FOUND": "File not found",
    "FILE_ACCESS_DENIED": "No permission for this file operation",
    "FILE_PATH_INVALID": "Invalid path",
    "FILE_TOO_LARGE": "The file is larger than the allowed limit",
    "FILE_TRANSFER_FAILED": "The file transfer failed",
    "CAMERA_PROBE_FAILED": "Could not probe the camera",
    "CAMERA_STREAM_FAILED": "The camera stream did not open",
    "STREAM_TICKET_INVALID": "The view ticket is invalid or expired",
    "MEDIA_SERVER_UNAVAILABLE": "The go2rtc media server is unavailable",
    "CODEC_UNSUPPORTED": "The browser does not understand this stream codec",
    "ARCHIVE_UNSUPPORTED": "The camera cannot serve its archive this way",
    "ARCHIVE_UNAVAILABLE": "The camera archive is unavailable right now",
    "STREAM_LIMIT_REACHED": "The limit of simultaneous streams is reached",
    "MASTER_KEY_MISSING": "Credential encryption is not configured",
    "DECRYPTION_FAILED": "Could not decrypt the credential"
  },
  "auth": {
    "required": "Sign in to continue",
    "sessionInvalid": "The session has expired or the token is invalid",
    "sessionMissing": "Session not found. Sign in again.",
    "sessionRevoked": "The session was ended for security reasons. Sign in again.",
    "sessionExpired": "The session has expired. Sign in again.",
    "badCredentials": "Wrong email or password",
    "userInactive": "The account is disabled",
    "wrongCurrentPassword": "The current password is wrong",
    "permissionsNotDeclared": "This action has no declared permissions",
    "needPermissions": "Not enough permissions. Required: {{list}}",
    "needAnyPermission": "Not enough permissions. One of these is required: {{list}}",
    "tooManyAttempts": "Too many sign-in attempts. Try again in {{seconds}} s."
  },
  "route": {
    "noAddress": "The node has no address, so there is nothing to connect to."
  },
  "agents": {
    "notFound": "Agent not found",
    "updateOffline": "Agent “{{name}}” is not connected, so there is nothing to update. Check whether the netdeck-agent service is running at the site.",
    "updateNotNeeded": "Agent “{{name}}” already runs the required version, or there is no build for its platform ({{platform}}).",
    "buildLinkInvalid": "The build link is invalid or has already been used",
    "buildSizeMismatch": "Build {{file}} on disk does not match the manifest size. Rebuild releases.json.",
    "buildUnknown": "The release catalogue has no “{{id}}”",
    "buildFileMissing": "File {{file}} is listed in the manifest but is missing from the release catalogue",
    "enrollTokenUsed": "The one-time token is invalid or already used. Issue a new one under Sites and agents.",
    "siteTaken": "Site \"{{site}}\" is already served by agent \"{{name}}\". Remove it from that agent or pick another: two agents on one site would run the same checks twice.",
    "probeOffline": "Agent “{{name}}” is not connected to the platform. Check whether the netdeck-agent service is running at the site.",
    "probeTimeout": "Agent “{{name}}” did not answer the connection request within {{ms}} ms. The site may be overloaded or the link unstable.",
    "probeFailed": "The agent could not connect to {{host}}:{{port}}: {{detail}}"
  },
  "sites": {
    "notFound": "Site not found"
  },
  "users": {
    "notFound": "User not found",
    "emailExists": "A user with this email already exists in the organization",
    "cannotDisableSelf": "You cannot disable your own account",
    "cannotResetOwnPassword": "Change your own password through Change password, not through a reset: a reset ends the current session.",
    "roleNotFound": "Role not found"
  },
  "organizations": {
    "notFound": "Organization not found",
    "slugExists": "An organization with the slug “{{slug}}” already exists"
  },
  "nodes": {
    "notFound": "Node not found",
    "notFoundAtSite": "This node is not on this site",
    "duplicateInBatch": "The same node appears twice in the batch",
    "groupNotFound": "Group not found",
    "groupSelfNesting": "A group cannot be nested inside itself",
    "groupIntoOwnChild": "A group cannot be nested inside its own subgroup",
    "linkNotFound": "Link not found",
    "layerNotFound": "Layer not found",
    "layerNotAtSite": "This layer is not on this site",
    "layerExists": "Layer “{{name}}” already exists on this site",
    "layerNotEmpty": "Layer “{{name}}” still holds {{nodes}} nodes and {{groups}} frames. Move them to another layer or delete them.",
    "lastLayer": "This is the site's only layer: without a layer the map has nowhere to put nodes.",
    "noLayers": "The site has no map layers",
    "frameOnOtherLayer": "Frame “{{name}}” is on another layer. A node and its frame must share one."
  },
  "monitors": {
    "notFound": "Monitor not found",
    "targetRequired": "The node has no address, so the check target must be given explicitly",
    "portRequired": "A {{kind}} check needs a port",
    "timeoutOverInterval": "The timeout must not exceed the check interval",
    "badConfig": "Invalid settings for a {{kind}} check",
    "agentOffline": "The site agent is not connected, so there is nobody to run the check. Check the netdeck-agent service under Agents.",
    "addressManaged": "Check settings of an additional address are inherited from the primary monitor of the node"
  },
  "credentials": {
    "notFound": "Credential not found",
    "secretTooLong": "The secret is longer than {{max}} characters",
    "passphraseOnlyForKey": "Only a private key can have a passphrase",
    "attachedToNodes": "The credential is attached to nodes ({{count}}). Detach it first.",
    "kindNotForService": "A “{{kind}}” credential cannot be attached to the “{{service}}” service",
    "notPrivateKey": "This is not a private key: a PEM starting with “-----BEGIN … PRIVATE KEY-----” is expected. A public key (id_rsa.pub) will not do.",
    "keyTruncated": "The key looks truncated: the closing “-----END … PRIVATE KEY-----” line is missing.",
    "keyEncryptedNoPassphrase": "The key is encrypted and no passphrase is set: connecting with it will not work."
  },
  "cameras": {
    "notFound": "Camera not found",
    "nodeNotFound": "The camera node was not found",
    "nodeNotCamera": "Node “{{name}}” is not a camera but a “{{kind}}”. Change the node type or pick another node.",
    "alreadyExists": "Node “{{name}}” already has a camera.",
    "disabled": "Camera “{{name}}” is disabled. Enable it in the camera settings.",
    "agentOffline": "The site agent is not connected, so the camera is out of reach. Check whether the netdeck-agent service is running.",
    "localPortFailed": "Could not open a local port for the camera stream.",
    "emptySdp": "Empty SDP offer: the browser sent no session description.",
    "ticketMismatch": "The ticket was issued for another camera or another user.",
    "viewTicketInvalid": "The view ticket is invalid or expired. Open the camera again.",
    "viewFinished": "The view has already ended. Open the camera again.",
    "ticketIssueFailed": "Could not issue a view ticket. Try again.",
    "streamLimit": "{{active}} of {{limit}} streams are open. Close some cells or pick a smaller layout.",
    "managedByRecorder": "This camera is channel {{channel}} of recorder “{{name}}”. Its paths and settings come from the recorder: change them in the recorder properties or detect the channels again."
  },
  "recorders": {
    "notFound": "Recorder not found",
    "nodeNotRecorder": "Node “{{name}}” is not a video recorder but a “{{kind}}”. Change the node type or pick another node.",
    "alreadyExists": "Node “{{name}}” already has a recorder.",
    "templateRequired": "A recorder without an API needs an RTSP path template with {channel} — otherwise there is nothing to build the channels from.",
    "noChannels": "The recorder returned no channels (checked up to {{max}}). Check the protocol, the port and the credentials, and for RTSP the path template.",
    "channelSilent": "Channel {{channel}} sent no video during channel detection: the input is empty or the camera behind it is offline.",
    "authFailed": "The recorder rejected the request: wrong login or password. Check the RTSP credential attached to the node — the recorder API uses the same one.",
    "httpStatus": "The recorder answered {{status}} to the {{path}} request. Check that the protocol is the right one and the web interface port is correct.",
    "dahuaUnexpected": "The recorder answered the Dahua channel request with something unexpected. The protocol is probably the wrong one.",
    "hikvisionUnexpected": "The recorder answered the ISAPI channel request with something unexpected. The protocol is probably the wrong one."
  },
  "media": {
    "go2rtcDown": "The go2rtc media server is not responding. Check whether the go2rtc service is running.",
    "go2rtcRejected": "The go2rtc media server rejected the request: {{detail}}",
    "proxyHostUnknown": "The go2rtc media server does not know the name “{{host}}” and cannot reach the platform's RTSP proxy. The camera is not at fault: the proxy carries cameras from closed segments and lives inside api. Set CAMERA_PROXY_ADVERTISE_HOST — the name under which go2rtc sees api: in Compose that is “api”, and when api runs as a host process while go2rtc runs in a container, “host.docker.internal”. Original media server reply: {{detail}}"
  },
  "layouts": {
    "notFound": "Layout not found",
    "sharedRequiresAdmin": "Shared layouts are created by the organization administrator. Save the layout as your own.",
    "sharedDeleteRequiresAdmin": "A shared layout is deleted by the organization administrator.",
    "foreignCameras": "The layout contains cameras from another organization."
  },
  "archive": {
    "cameraAuthFailed": "The camera rejected the {{what}} request: wrong login or password. Check the RTSP credential attached to the node — the camera's web interface uses the same one.",
    "cameraUnknownRequest": "The camera does not know the {{what}} request (404). The archive provider is probably the wrong one.",
    "cameraStatus": "The camera answered {{status}} to the {{what}} request.",
    "cameraStatusDetail": "The camera answered {{status}} to the {{what}} request: {{detail}}.",
    "cameraStatusAsked": "The camera answered {{status}} to the {{what}} request. Requested: {{path}}",
    "cameraStatusDetailAsked": "The camera answered {{status}} to the {{what}} request: {{detail}}. Requested: {{path}}",
    "cameraHttpDown": "The camera does not answer over HTTP: {{detail}}. Check whether its web interface is enabled and whether the port in the archive settings is right.",
    "responseTooLong": "The camera sent an implausibly long reply to the recording list request.",
    "exportTooLong": "At most {{max}} minutes of recording can be exported at once. Longer fragments take the site's bandwidth away from live video.",
    "exportUnsupported": "The selected archive provider cannot serve a fragment as a file. The recording can be watched but not exported.",
    "exportRefused": "The camera refused to serve the fragment ({{status}}). Check that the recording for this interval has not been overwritten yet.",
    "providerUnknown": "The platform does not know the archive provider “{{provider}}”.",
    "dahuaNoFiles": "The camera found no recording files in the selected interval.",
    "dahuaUnexpected": "The camera answered the search request with something unexpected. The archive provider is probably the wrong one.",
    "dahuaAllFormsRejected": "The camera rejected every known form of the recording list request (400 Error). Its CGI apparently differs from Dahua more than expected: check that the archive provider and the channel number are right. Tried: {{tried}}",
    "hikvisionUnexpected": "The camera answered the ISAPI request with something unexpected. The archive provider is probably the wrong one.",
    "rtspTemplateSlash": "The archive address template must start with a slash, but it reads “{{path}}”. Fix it in the camera's archive settings.",
    "cameraSilent": "Camera “{{name}}” did not answer the archive request. Check whether its web interface responds."
  },
  "discovery": {
    "alreadyRunning": "A scan of site “{{name}}” is already running. Wait for it to finish or open its result.",
    "agentOffline": "Agent “{{name}}” is not connected, so there is nobody to scan the subnet. Check whether the netdeck-agent service is running at the site.",
    "agentNotAtSite": "The site is now served by a different agent. Refresh the page and try again: the scan must run from the segment the site is actually in.",
    "noAgents": "The site has no agent. Add one under Agents and start it on the site server — there is nobody else to scan the subnet.",
    "agentSilent": "The agent sent no result within five minutes. Check the link to the site and its log, then scan again."
  },
  "files": {
    "gatewayNoContent": "The access gateway sent no file content.",
    "gatewayDown": "The access gateway is not responding. Check whether the netdeck-access-gateway service is running.",
    "gatewayRejected": "The access gateway rejected the file operation (HTTP {{status}}).",
    "internalChannelMissing": "The internal channel to the access gateway is not configured: NETDECK_INTERNAL_TOKEN is not set.",
    "noFileInRequest": "The request carries no file: a multipart with a path field and a file is expected.",
    "noPathField": "The multipart has no path field. It must come before the file.",
    "foreignSession": "Files are reachable only through your own session: someone else's session is someone else's connection to the machine.",
    "sessionClosed": "The session is closed: file access to the machine ended with it.",
    "pathTraversal": "Invalid path: “..” segments are not allowed.",
    "pathInvalid": "Invalid path: {{path}}",
    "postExpected": "POST expected",
    "notFoundAt": "The machine has no {{path}}.",
    "fileNotFoundAt": "The machine has no file {{path}}.",
    "isDirectory": "{{path}} is a directory, not a file.",
    "noSuchPath": "The machine has no such path: {{detail}}.",
    "accessDenied": "The user has no permission for this operation: {{detail}}.",
    "serverRejected": "The server rejected the operation: {{detail}}",
    "sftpOperationUnsupported": "The server does not support this SFTP operation: {{detail}}.",
    "sftpNoConnectionParams": "The SFTP file request arrived without connection parameters.",
    "operationFailed": "The operation failed: {{detail}}.",
    "protocolViolation": "The server answered off-protocol: {{detail}}",
    "uploadHeaderMissing": "The {{header}} header with upload parameters is missing.",
    "transferUnsupported": "The server ({{kind}}) did not announce file transfer. The extension exists only in TightVNC and only when it is enabled in its settings.",
    "channelClosed": "The file channel is closed. Open files again.",
    "handshakeTimeout": "Server {{host}}:{{port}} did not finish the file channel handshake within {{seconds}} s.",
    "streamCutShort": "The stream broke off before the end of the file.",
    "tooLarge": "File {{name}} of {{size, bytes}} exceeds the {{limit, bytes}} limit for a single transfer.",
    "tooManyTransfers": "This session already has {{active}} transfers of {{limit}} running. Wait for one to finish or cancel it."
  },
  "sessions": {
    "notFound": "Session not found",
    "closeForeignForbidden": "Only the organization administrator may end other people's sessions",
    "perUserLimit": "{{open}} of {{limit}} sessions are already open. Close one of them.",
    "perOrgLimit": "The organization already has {{open}} of {{limit}} sessions open."
  },
  "notifications": {
    "channelNotFound": "Notification channel not found",
    "ruleNotFound": "Notification rule not found",
    "telegramTokenRequired": "A Telegram channel needs a bot token: get one from @BotFather and paste it into the Token field.",
    "badChannelConfig": "Invalid settings for a “{{kind}}” channel",
    "smtpNotConfigured": "The platform mail server is not configured: set SMTP_URL and SMTP_FROM in its environment. Without them the e-mail channel does not work; Telegram and webhook do.",
    "telegramTokenMissing": "The Telegram channel has no bot token: get one from @BotFather and put it in the channel settings.",
    "telegramRejected": "Telegram rejected the message ({{status}}). Check the bot token and that the bot was added to the chat. Telegram replied: {{detail}}",
    "signingKeyMissing": "Signing is enabled for the channel but no signing key is set: put one in the channel settings or turn signing off.",
    "webhookRejected": "The webhook receiver replied {{status}}. Check the address and that the receiver accepts a POST with a JSON body. It replied: {{detail}}",
    "unknownSendFailure": "Sending failed for an unknown reason. The details are in the api log for this moment."
  },
  "ssh": {
    "hostKeyConfirmForbidden": "Confirming a host key change is for those trusted with credentials.",
    "hostKeyServerSilent": "The server is not responding: there is nothing to confirm, the key could not be read.",
    "hostKeyChangedAgain": "The server now presents a different key from the one you were shown. Open the server details again and compare the fingerprint.",
    "hostKeyChanged": "The host key of {{host}} differs from the one the platform remembers. That is what a server reinstall looks like — and also what an impersonated machine looks like: until the reason is clear, the connection will not proceed and no password will go to this server.",
    "hostKeyUntrusted": "The host key of {{host}} is not pinned, and it cannot be pinned from here.",
    "credentialMissing": "Connecting to {{host}} needs an SSH credential, and none is attached to the node.",
    "usernameMissing": "The credential attached to the node has no username.",
    "internalChannelMissing": "The internal channel to the access gateway is not configured: NETDECK_INTERNAL_TOKEN is not set.",
    "gatewayDown": "The access gateway is not responding. Check whether the netdeck-access-gateway service is running.",
    "gatewayTimeout": "The access gateway did not answer within {{seconds}} s. The service is running, but the probe never finished — the reason is in the netdeck-access-gateway log.",
    "gatewayProbeRejected": "The access gateway rejected the probe request (HTTP {{status}}).",
    "ticketIssueFailed": "Could not issue a session ticket. Try again.",
    "protocolViolation": "The server broke the SSH protocol: {{detail}}.",
    "noAlgorithmAtAll": "The server supports no {{kind}} algorithm the platform knows, not even a legacy one. The platform cannot serve such equipment.",
    "noModernAlgorithm": "The server supports no {{kind}} algorithm from the modern set. If this is old network equipment, enable “legacy algorithms” on the node.",
    "authRejected": "The server rejected the login of {{username}} ({{method}}).",
    "methodUnsupported": "The server does not accept the “{{method}}” login method. It offers: {{offered}}.",
    "methodUnsupportedSilent": "The server does not accept the “{{method}}” login method and did not say which methods it accepts.",
    "interactivePrompt": "The server asks for something the platform cannot answer for you: “{{prompt}}”. Such a login (a one-time code, for example) is not possible through the platform.",
    "noCredential": "Connecting to {{host}}:{{port}} needs a credential, and none is attached to the node.",
    "keyNeedsPassphrase": "The private key is encrypted and the passphrase is missing or wrong.",
    "keyUnreadable": "The private key could not be read: {{detail}}.",
    "sftpUnsupported": "The server does not support file transfer over SFTP. The terminal still works.",
    "connectFailed": "Could not connect to {{host}}:{{port}} over SSH: {{detail}}."
  },
  "vnc": {
    "internalChannelMissing": "The internal channel to the access gateway is not configured: NETDECK_INTERNAL_TOKEN is not set.",
    "gatewayDown": "The access gateway is not responding. Check whether the netdeck-access-gateway service is running.",
    "gatewayProbeRejected": "The access gateway rejected the probe request (HTTP {{status}}).",
    "ticketIssueFailed": "Could not issue a session ticket. Try again.",
    "versionUnsupported": "The server speaks RFB version “{{banner}}”, and the platform supports 3.3, 3.7 and 3.8.",
    "noSecurityTypes": "The server offered no security type at all.",
    "securityTypeUnsupported": "The server requires authentication the platform does not support: {{types}}. Supported are 1 (none), 2 (VNC Authentication) and 16 (Tight).",
    "authFailed": "The server rejected the VNC password.",
    "authFailedWithReason": "The server rejected the VNC password: {{reason}}.",
    "noCredential": "Server {{host}}:{{port}} requires a password, and no VNC credential is attached to the node.",
    "noCredentialHere": "The server requires a password, and no VNC credential is attached to the node.",
    "protocolViolation": "The server broke the RFB protocol: {{detail}}."
  },
  "gateway": {
    "service": {
      "vnc": "the VNC server",
      "ssh": "the SSH server"
    },
    "reason": {
      "noRoute": "there is no route to it",
      "netUnreachable": "the network is unreachable",
      "nameNotResolved": "the name does not resolve to an address",
      "connectionReset": "the connection was reset"
    },
    "portClosed": "Port {{port}} on {{host}} is closed: {{service}} is not running or listens on another port.",
    "hostUnreachable": "Node {{host}} is unreachable: {{detail}}.",
    "timedOut": "Server {{host}}:{{port}} did not answer within {{seconds}} s.",
    "serverClosed": "The server closed the connection without giving a reason.",
    "serverClosedWithReason": "The server closed the connection: {{reason}}.",
    "connectFailed": "Could not connect to {{host}}:{{port}}: {{detail}}.",
    "handshakeTimeout": "Server {{host}}:{{port}} did not finish the handshake within {{seconds}} s.",
    "routeAgentMissing": "An agent route was chosen, but no agent was given.",
    "internalChannelMissing": "The internal channel to api is not configured: NETDECK_INTERNAL_TOKEN is not set. Connecting through a site agent is not possible.",
    "internalChannelRejected": "api rejected the gateway on the internal channel: the NETDECK_INTERNAL_TOKEN secrets do not match.",
    "internalChannelClosed": "The internal channel closed with code {{code}}.",
    "internalChannelClosedWithReason": "The internal channel closed with code {{code}}: {{reason}}.",
    "agentOffline": "The site agent is not connected. Check whether the netdeck-agent service is running.",
    "agentLost": "The link to the site agent broke while it was working.",
    "agentConnectFailed": "The site agent could not connect to {{host}}:{{port}}: {{reason}}.",
    "agentConnectFailedSilent": "The site agent could not connect to {{host}}:{{port}}: no reason was given.",
    "badProbeRequest": "Malformed probe request"
  },
  "tunnel": {
    "agentOffline": "The site agent is not connected. Check whether the netdeck-agent service is running.",
    "closed": "The tunnel to the site agent is closed. Wait for the agent to reconnect, or check the netdeck-agent service at the site.",
    "agentNoAnswer": "The site agent did not answer a connection request to {{host}}:{{port}} within {{ms}} ms. Check that the device is powered on and that the agent can see it."
  },
  "secrets": {
    "masterKeyNotSet": "Credential encryption is unavailable: the {{env}} variable is not set. Set it (base64 of 32 bytes) and restart the service.",
    "masterKeyEmpty": "Credential encryption is unavailable: the {{env}} variable is empty. Set it (base64 of 32 bytes) and restart the service.",
    "masterKeyNotBase64": "Credential encryption is unavailable: the {{env}} variable is not valid base64. Set it again and restart the service.",
    "masterKeyWrongSize": "Credential encryption is unavailable: the master key must be {{expected}} bytes, got {{actual}}. Generate a new key and restart the service.",
    "keyVersionMismatch": "Could not decrypt the credential: the record is encrypted with key version {{sealed}}, while the environment carries version {{current}}.",
    "corruptedEnvelope": "Could not decrypt the credential: the initialization vector or the authentication tag is damaged.",
    "wrongKeyOrCorrupted": "Could not decrypt the credential: wrong key, or the record is damaged."
  },
  "internal": "Internal platform error. Try again; if it keeps failing, show the administrator the api log for this moment — it holds a record with the details.",
  "telemetry": {
    "jsonExpected": "A JSON message is expected.",
    "unknownMessage": "Unknown message.",
    "noMonitorRead": "No permission to read monitors."
  },
  "health": {
    "probeTimeout": "The dependency did not answer within {{ms}} ms.",
    "unknown": "Unknown dependency failure."
  }
}
